import { service } from '../../../helpers/http'

export const ActionFindInstitutionTypeRules = ({ dispatch }, payload) => {

    return service({
        module: 'institutionTypeRule',
        action: 'find',
        payload: payload
    })

}

export const ActionFindCurrentInstitutionTypeRule = ({ dispatch }, payload) => {

    return service({
        module: 'institutionTypeRule',
        action: 'current',
        payload: payload
    })

}

export const ActionCreateInstitutionTypeRule = ({ dispatch }, payload) => {

    return service({
        module: 'institutionTypeRule',
        action: 'create',
        payload: payload
    })

}

export const ActionUpdateInstitutionTypeRule = ({ dispatch }, payload) => {

    return service({
        module: 'institutionTypeRule',
        action: 'update',
        payload: payload
    })
}

export const ActionDeleteInstitutionTypeRule = ({ dispatch }, payload) => {

    return service({
        module: 'institutionTypeRule',
        action: 'delete',
        payload: payload
    })

}
